/* v2 — error message below input, bundle check, clearIfExpired */
/**
 * Onix Cart — Discount code handler
 * ──────────────────────────────────
 * Owns the `#onix-discount-input` / `#onix-discount-apply` pair in the
 * cart drawer footer. Handles apply, verify (Shopify's /discount/CODE
 * endpoint always returns 200 so we post-check the cart for the title),
 * remove, used-code blacklist, and bundle-active guard.
 *
 * Pulls shared helpers from `window.OnixCart` (cart-drawer-utils.js).
 * Load order: utils → cart-drawer → quickadd → this
 */
(function () {
  const OnixCart = window.OnixCart || {};
  const loggedFetch = OnixCart.loggedFetch || fetch.bind(window);
  var LROOT=(window.OnixCart&&window.OnixCart.cartRoot)||(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/'; if(LROOT.slice(-1)!=='/')LROOT+='/';

  function initDiscount() {
    const applyBtn = document.getElementById('onix-discount-apply');
    const input = document.getElementById('onix-discount-input');
    if (!applyBtn || !input) return;

    /* Translation strings from data-t-* attributes on the drawer root. */
    const _dr = document.querySelector('[data-cart-drawer-root]');
    const qt = {
      error: (_dr && _dr.dataset.tError) || 'Code invalide',
      alreadyUsed: (_dr && _dr.dataset.tAlreadyUsed) || 'Déjà utilisé',
      /* « deja UTILISE » = consomme par une commande passee.
         « deja APPLIQUE » = actif sur le panier en cours. Deux choses. */
      alreadyApplied: (_dr && _dr.dataset.tAlreadyApplied) || 'Ce code est déjà appliqué.',
      bundleOnly: (_dr && _dr.dataset.tDiscountBundleOnly) || 'Non cumulable avec l\'offre',
    };

    /* ═══ LE MESSAGE SOUS LE CHAMP ═══════════════════════════════════
       Il remplace l'ancien affichage dans le libellé du bouton.

       ⚠️ IL EXISTE AVANT D'ÊTRE REMPLI, et ce n'est pas un détail de style.
         Il était CRÉÉ PUIS INSÉRÉ au moment de l'erreur : une région live qui
         ARRIVE dans le DOM n'est annoncée de façon fiable par aucun lecteur
         d'écran, alors qu'un texte qui ENTRE dans une région déjà présente
         l'est. Le client qui n'a pas vu le message rouge n'apprenait donc rien
         du tout — ni ce qui s'est passé, ni quoi corriger.
       ⚠️ Vide, il ne prend AUCUNE place : un bloc sans contenu n'ouvre pas de
         ligne, et sa marge n'est posée qu'avec le texte. `display:none` aurait
         sorti la région de l'arbre d'accessibilité, ce qu'on cherche justement
         à éviter.
       ⚠️ La COULEUR se décide au moment du message, pas ici : « il te manque un
         maillot » n'est pas une erreur, et le rouge disait le contraire du
         texte. */
    let _msgEl = null;
    function zoneMessage() {
      if (_msgEl && _msgEl.isConnected) return _msgEl;
      _msgEl = document.createElement('p');
      _msgEl.className = 'onix-cart-drawer__discount-error';
      _msgEl.id = 'onix-discount-message';
      _msgEl.setAttribute('role', 'alert');
      _msgEl.setAttribute('aria-live', 'assertive');
      _msgEl.style.cssText = 'margin:0;font-size:0.75rem;font-weight:600;text-align:left;';
      /* le champ vit dans <details.onix-code><div.onix-code__corps> depuis le
         18/08 — l'ancienne .onix-cart-drawer__discount-row n'existe plus */
      const row = input.closest('.onix-code__corps') || input.parentElement;
      if (row && row.parentElement) {
        row.parentElement.insertBefore(_msgEl, row.nextSibling);
      }
      return _msgEl;
    }
    zoneMessage();

    /* `ton` vaut 'refus' (rouge — ce code ne passera pas) ou 'chemin' (accent —
       le code est bon, il reste un geste à faire côté panier). */
    function poserMessage(msg, ton) {
      const el = zoneMessage();
      el.textContent = msg;
      el.style.margin = '0.4rem 0 0';
      el.style.color = ton === 'chemin' ? 'var(--c-accent, #00c8ff)' : 'var(--c-error, #ef4444)';
      /* Le champ garde sa saisie : `aria-describedby` fait relire le message à
         qui y revient au clavier, et `aria-invalid` n'est posé que sur un vrai
         refus — un code valide n'est pas une saisie fautive. */
      input.setAttribute('aria-describedby', el.id);
      if (ton === 'chemin') input.removeAttribute('aria-invalid');
      else input.setAttribute('aria-invalid', 'true');
    }
    function effacerMessage() {
      if (_msgEl) {
        _msgEl.textContent = '';
        _msgEl.style.margin = '0';
      }
      input.removeAttribute('aria-describedby');
      input.removeAttribute('aria-invalid');
    }

    /* ⚠️ LE BOUTON CHANGE DE FONCTION, DONC IL DOIT CHANGER DE NOM — trouvé
         le 20/08 en testant le site EN LIGNE comme un client. Il bascule entre
         « appliquer » (✓) et « retirer » (✕), mais son `aria-label` restait
         « Appliquer » dans les deux états : un lecteur d'écran annonçait
         « Appliquer » sur un bouton qui RETIRE le code.
       ⚠️ Et son fond rouge ne repartait pas : après le retrait, on lisait un
         ✓ sur fond ROUGE — l'icône disait « appliquer », la couleur disait
         « erreur ». `removeProperty` plutôt que `= ''`, qui laissait une
         déclaration vide sur l'attribut style. */
    var racineTiroir = document.querySelector('[data-cart-drawer-root]');
    var MOT_APPLIQUER = applyBtn.getAttribute('aria-label') || 'Appliquer';
    var MOT_RETIRER = (racineTiroir && racineTiroir.dataset.tRemoveCode) || 'Retirer le code';
    function etatBouton(retrait) {
      applyBtn.textContent = retrait ? '\u2715' : '\u2713';
      applyBtn.setAttribute('aria-label', retrait ? MOT_RETIRER : MOT_APPLIQUER);
      applyBtn.setAttribute('title', retrait ? MOT_RETIRER : MOT_APPLIQUER);
      if (retrait) {
        applyBtn.style.background = '#ef4444';
        applyBtn.style.color = '#fff';
        applyBtn.style.fontWeight = '700';
      } else {
        applyBtn.style.removeProperty('background');
        applyBtn.style.removeProperty('color');
        applyBtn.style.removeProperty('font-weight');
      }
      applyBtn.style.removeProperty('font-size');
      applyBtn.disabled = false;
      applyBtn.__removeMode = !!retrait;
      /* on note QUAND le bouton a pris son rôle de retrait : la fenêtre de
         grâce du double-tap se compte à partir de là, quel que soit le chemin */
      if (retrait) applyBtn.__basculeA = Date.now();
    }

    /* Put the discount UI into "applied/remove" mode for a given code. */
    function setAppliedState(code) {
      /* ⚠️ LE MESSAGE D'ERREUR NE SURVIT PAS À SA PROPRE RÉUSSITE.
         `effacerMessage()` n'était appelé qu'à l'ENTRÉE d'applyDiscount et sur
         la saisie : un « Ajoute 1 maillot pour -15% » restait donc affiché sous
         un code qui venait de s'appliquer, et le client lisait un reproche à
         côté de sa remise obtenue. Un état de réussite efface l'état d'échec qui
         l'a précédé — c'est le seul endroit qui sait qu'on a réussi. */
      effacerMessage();
      window.__onixDiscountCode = code;
      input.value = code;
      input.disabled = true;
      etatBouton(true);
    }

    /* Restore the input if a non-bundle discount is already applied
       server-side (user applied code -> checkout -> back). The code must
       remain visible until the user explicitly clicks ✕.
       SKIP entirely when bundle is active — the bundle has its own
       internal discount code that should NOT appear in the user-facing
       input (otherwise users see the internal code and get confused). */
    async function restoreAppliedDiscount() {
      try {
        /* If bundle items are in the cart, don't show any discount in the
           input — the only active discount is the bundle's internal one. */
        if (await bundleIsActive()) return;

        const res = await loggedFetch(LROOT + 'cart.js', { headers: { Accept: 'application/json' } });
        const c = await res.json();
        const titles = [];
        (c.cart_level_discount_applications || []).forEach(a => { if (a.title) titles.push(a.title); });
        (c.items || []).forEach(i => {
          (i.discounts || []).forEach(d => { if (d.title) titles.push(d.title); });
          (i.line_level_discount_allocations || []).forEach(a => {
            if (a.discount_application && a.discount_application.title) titles.push(a.discount_application.title);
          });
        });
        const bundleCode = (window.__onixOfferDiscountCode || '').toUpperCase();
        const nonBundle = titles.find(t => t && t.toUpperCase() !== bundleCode);
        if (nonBundle && !applyBtn.__removeMode) {
          setAppliedState(nonBundle);
        }
      } catch (e) { /* noop */ }
    }
    restoreAppliedDiscount();

    /* If a discount was applied but the server no longer has it (e.g. user
       removed items and cart no longer qualifies), clear the UI. Without
       this, the ✕ button and code text stay visible after a cart refresh
       even though the discount is gone server-side. */
    async function clearIfExpired() {
      if (!applyBtn.__removeMode) return;
      try {
        const res = await loggedFetch(LROOT + 'cart.js', { headers: { Accept: 'application/json' } });
        const c = await res.json();
        const titles = [];
        (c.cart_level_discount_applications || []).forEach(a => { if (a.title) titles.push(a.title.toUpperCase()); });
        (c.items || []).forEach(i => {
          (i.discounts || []).forEach(d => { if (d.title) titles.push(d.title.toUpperCase()); });
          (i.line_level_discount_allocations || []).forEach(a => {
            if (a.discount_application && a.discount_application.title) titles.push(a.discount_application.title.toUpperCase());
          });
        });
        const currentCode = (input.value || '').toUpperCase();
        if (currentCode && !titles.includes(currentCode)) {
          /* Server dropped the discount — reset UI to clean state */
          window.__onixDiscountCode = null;
          sessionStorage.removeItem('onix_pending_discount');
          input.disabled = false;
          input.value = '';
          etatBouton(false);
        }
      } catch (e) {
        console.warn('[onix-cart] clearIfExpired failed', e);
      }
    }

    /* Re-check after every cart refresh — handles BOTH cases:
       1. No code applied → try to restore from server (e.g. back from checkout)
       2. Code applied → verify it's still active, clear UI if server dropped it */
    document.addEventListener('cart:refresh', () => {
      if (applyBtn.__removeMode) {
        clearIfExpired();
      } else {
        restoreAppliedDiscount();
      }
    });
    /* Re-run on bfcache restore (browser back from checkout). */
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) restoreAppliedDiscount();
    });

    function getUsedCodes() {
      try {
        return JSON.parse(localStorage.getItem('onix_used_discounts') || '[]');
      } catch (e) { return []; }
    }

    function markCodeUsed(code) {
      const used = getUsedCodes();
      if (!used.includes(code.toUpperCase())) {
        used.push(code.toUpperCase());
        try { localStorage.setItem('onix_used_discounts', JSON.stringify(used)); } catch (_) {}
      }
    }

    function isCodeUsed(code) {
      return getUsedCodes().includes(code.toUpperCase());
    }

    // Mark a code "used" ONLY after a genuinely completed order — i.e.
    // the customer is coming back from the order-confirmation page.
    // We match the thank-you page only (tolerant to Shopify's
    // /thank_you and /thank-you URL variants), NOT '/checkouts/' alone:
    // merely reaching checkout and abandoning must NOT burn the code.
    // If document.referrer is empty (strict referrer-policy) the guard
    // simply doesn't fire — fail-open, a paying customer is never
    // wrongly blocked from re-using their code.
    try {
      if (/\/thank[_-]you/i.test(document.referrer || '')) {
        const lastCode = sessionStorage.getItem('onix_pending_discount');
        if (lastCode) {
          markCodeUsed(lastCode);
          sessionStorage.removeItem('onix_pending_discount');
        }
      }
    } catch (_) {}

    /* True when a bundle offer is currently in the cart. User discount
       codes are NOT stackable with the bundle — block apply.
       Previously also checked window.__onixOfferPriceCents > 0 but that
       variable is only set by the offer popup JS and isn't always defined
       (e.g. on page reload, bfcache, or if the popup hasn't opened yet).
       The cart items themselves are the source of truth. */
    async function bundleIsActive() {
      try {
        const c = await loggedFetch(LROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        return (c.items || []).some(i => i.properties && i.properties._offer_bundle === 'true');
      } catch (e) {
        console.warn('[onix-cart] bundleIsActive check failed', e);
        return false;
      }
    }

    /* ═══ POURQUOI LE CODE N'EST PAS PASSÉ ═══════════════════════════
       Jusqu'au 23/08, TROIS raisons de refus tenaient dans UNE phrase :
       « Code invalide ». Un code de palier parfaitement valide, tapé sur un
       panier qui n'atteint pas encore son minimum, était donc annoncé FAUX —
       le client repartait en croyant s'être trompé alors qu'il lui manquait
       un maillot. Shopify le disait pourtant en clair dans la même réponse :
       le code entre dans `cart.discount_codes` avec `applicable: false`, et
       `data-tiers` donne le seuil exact. Rien de tout ça n'était lu. */

    /* Les paliers, à leur SEULE source : `data-tiers` de #onix-promo-suggest.
       Trois modules la lisent déjà ainsi (cart-drawer.js, promo-suggest,
       second-jersey) ; une liste recopiée ici serait la quatrième à tenir à
       jour, et la première à mentir. */
    function paliers() {
      const src = document.getElementById('onix-promo-suggest');
      try { return JSON.parse((src && src.dataset.tiers) || '[]'); }
      catch (e) { return []; }
    }

    /* Shopify a-t-il VU ce code ? Un code qu'il connaît et qu'il refuse
       d'appliquer reste dans la session avec `applicable: false` — c'est le
       drapeau que le chemin d'échec ne consultait jamais. */
    function codeVuParShopify(code, cart) {
      return (cart.discount_codes || []).some((d) =>
        d.code && d.code.toUpperCase() === code.toUpperCase() && d.applicable === false);
    }

    /* Le palier de ce code et ce qui manque pour l'atteindre, ou null quand la
       question ne se pose pas (code hors paliers, ou seuil déjà atteint).
       ⚠️ Le compte EXCLUT les articles de l'offre découverte, exactement comme
         la jauge et l'échelle (cart-drawer-promo-suggest.js) : un palier ne
         compte que les maillots du chemin normal. */
    function palierIncomplet(code, cart) {
      const palier = paliers().find((t) => String(t.code).toUpperCase() === code.toUpperCase());
      if (!palier) return null;
      const bundleQty = (cart.items || []).reduce((s, i) =>
        s + ((i.properties && i.properties._offer_bundle === 'true') ? (i.quantity || 0) : 0), 0);
      const compte = Math.max(0, (cart.item_count || 0) - bundleQty);
      const manque = Math.max(0, (palier.qty || 0) - compte);
      return manque > 0 ? { palier, manque } : null;
    }

    /* La phrase « il manque N maillots » n'est PAS écrite ici : c'est celle de
       la barre de progression (`cart.progress_remaining`), déjà traduite en
       cinq langues et exposée en `data-t-*` par #onix-cart-progress. Le
       conteneur survit à la dépose du message du 18/08 précisément pour porter
       ces libellés. `{{price}}` reçoit le libellé du palier (« -15% ») et non
       un prix marginal : celui-ci se calcule dans la jauge, et deux formules
       pour la même chose finissent par diverger. */
    function texteManque(manque, palier) {
      const prog = document.getElementById('onix-cart-progress');
      const modele = (prog && prog.dataset.tRemaining) || 'Ajoute {{n}} {{item}} pour {{price}} 🔥';
      const un = (prog && prog.dataset.tItem) || 'maillot';
      const pluriel = (prog && prog.dataset.tItemPlural) || 'maillots';
      return modele
        .replace('{{n}}', manque)
        .replace('{{item}}', manque > 1 ? pluriel : un)
        .replace('{{price}}', palier.label || '')
        .replace('{{label}}', palier.label || '');
    }

    /* Le code n'a pas pris — on dit LAQUELLE des trois raisons, dans cet ordre :
        1. offre découverte au panier → le code ne passera jamais, quel que soit
           le nombre de maillots ; « ajoute un maillot » serait un mensonge.
           Repli sur « Code invalide » si `window.OnixValidCodes` est absent (la
           barre n'est pas rendue sur les fiches produit) — le cas de la faute
           de frappe reste le plus probable.
        2. code de palier connu, seuil non atteint, et Shopify confirme l'avoir
           vu → on dit CE QU'IL MANQUE. Les deux preuves sont exigées ensemble :
           un code que Shopify n'a même pas enregistré ne mérite pas qu'on
           promette au client qu'il marchera au maillot suivant.
        3. le reste → le code n'existe pas. */
    function refuser(code, cart, bundleActive) {
      let texte = qt.error;
      let ton = 'refus';

      if (bundleActive) {
        const connus = Array.isArray(window.OnixValidCodes) ? window.OnixValidCodes : [];
        if (connus.includes(code.toUpperCase())) texte = qt.bundleOnly;
      } else {
        const incomplet = palierIncomplet(code, cart);
        if (incomplet && codeVuParShopify(code, cart)) {
          texte = texteManque(incomplet.manque, incomplet.palier);
          ton = 'chemin';
        }
      }

      poserMessage(texte, ton);
      /* ⚠️ UN MESSAGE DANS UN TIROIR FERMÉ N'EST PAS UN MESSAGE.
         Le bloc code vit dans un `<details class="onix-code">` : replié, il ne
         rend que son `<summary>`, donc ni le refus ni le « il te manque N
         maillots » n'atteignaient le client sur le chemin AUTOMATIQUE (celui
         où c'est le thème, et non le client, qui tente le code).
         On ouvre le tiroir quand on a quelque chose à y dire. */
      try {
        const repli = input && input.closest('details');
        if (repli && !repli.open) repli.open = true;
      } catch (e) { /* pas de <details> : rien à ouvrir */ }
      /* Bordure rouge et secousse SEULEMENT sur un refus : elles disent « ta
         saisie est fautive », ce qui est faux quand le code est bon. */
      if (ton === 'refus') input.classList.add('onix-cart-drawer__discount-input--error');
      else input.classList.remove('onix-cart-drawer__discount-input--error');
      /* ⚠️ LA SAISIE RESTE. Elle était effacée : le client à qui le message
         avait échappé n'avait plus rien à corriger ni même à relire. */
      etatBouton(false);
    }

    async function applyDiscount() {
      const code = input.value.trim();
      if (!code) return;
      if (input.disabled) return;

      /* Toute nouvelle tentative efface le verdict précédent. Sans ça, un
         message de refus survivait à l'application réussie du code suivant
         quand la saisie n'était pas passée par le clavier — c'est le cas de
         `__onixMarquerCodePose` / `__onixAppliquerCode`, qui écrivent dans le
         champ sans déclencher d'événement `input`. Au passage, retirer la
         classe permet à la secousse de rejouer sur un second refus. */
      effacerMessage();
      input.classList.remove('onix-cart-drawer__discount-input--error');

      // Check if code was already used
      if (isCodeUsed(code)) {
        poserMessage(qt.alreadyUsed, 'refus');
        input.classList.add('onix-cart-drawer__discount-input--error');
        return;
      }

      /* ⛔ RE-APPLIQUER UN CODE DÉJÀ ACTIF LE FAISAIT SAUTER — 31/08, 04h35.
           Mesuré, thème en ligne ET thème de dev : panier 2 maillots, on tape
           `onix3` → 37,40. On retape `onix3` → **44,00**, plein tarif. La
           remise disparaît au lieu d'être conservée.
           Cause : l'application efface la session (`discount=`) avant de
           reposer le code — quand le code reposé est le même que celui qu'on
           vient d'effacer, l'effacement l'emporte et le panier ressort nu.
           `isCodeUsed` ne protégeait pas : il ne parle que des codes CONSOMMÉS
           par une commande passée, pas de ceux ACTIFS sur le panier courant.
           ➜ Un code déjà actif ne se réapplique pas. On le dit et on sort,
             AVANT toute écriture de session : la mécanique d'empilement, qui a
             ses propres pièges documentés, n'est pas touchée.
           ⚠️ Un double-tap sur le ✓ est le geste le plus banal du mobile. */
      try {
        const cActuel = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
          .then((r) => r.json());
        const actifs = (cActuel.cart_level_discount_applications || [])
          .map((x) => String(x.title || '').toUpperCase());
        if (actifs.includes(String(code).toUpperCase())) {
          poserMessage(qt.alreadyApplied, 'info');
          return;
        }
      } catch (e) { /* panier illisible : on laisse le chemin normal décider */ }

      applyBtn.textContent = '...';
      applyBtn.disabled = true;

      try {
        /* Step 1: Bundle in cart + typed code is a merchant tier code
           (window.OnixValidCodes) → re-apply oniix then the tier code
           in sequence. Whether they STACK is decided by oniix's Shopify
           `combinesWith`, NOT here: if oniix is non-combinable (current
           config) Shopify keeps only oniix, the verify step below fails
           for the tier code, and we fall through to "Non cumulable avec
           l'offre". Both outcomes are intended — check oniix combinesWith
           before changing this path. Non-whitelisted codes skip this and
           hit the rejection path below. */
        const bundleActive = await bundleIsActive();
        /* Code offre à ré-appliquer (codes renommés en illisible 2026-06-19) :
           posé par le popup dans window.__onixOfferDiscountCode ; fallback
           selon la devise (4-pack par défaut). Le gate count+devise recolle
           de toute façon le bon code au cart:refresh suivant. */
        const ddIsEUR = ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR') === 'EUR';
        const bundleCode = (window.__onixOfferDiscountCode || (ddIsEUR ? 'B8Z3P4WH' : 'D8K4H2NV')).toUpperCase();
        const whitelist = Array.isArray(window.OnixValidCodes) ? window.OnixValidCodes : [];
        const isStackableTierCode = whitelist.includes(code.toUpperCase());

        /* Step 2: Apply the code(s) on Shopify. The /discount/CODE
           endpoint takes ONE code per call — comma-separated values
           are treated as a single literal code and rejected. So when
           we need to stack (bundle active + stackable tier code), we
           call the endpoint TWICE in sequence; Shopify keeps both
           because their combinesWith config allows it.
           For non-stackable cases we just call once and let the
           verify+rejection path below handle non-cumul codes. */
        if (bundleActive && isStackableTierCode) {
          /* Clear first so a stale tier code from a previous attempt
             doesn't poison the stack. */
          await loggedFetch(LROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'discount='
          });
          await loggedFetch(LROOT + 'discount/' + encodeURIComponent(bundleCode));
          await loggedFetch(LROOT + 'discount/' + encodeURIComponent(code));
        } else {
          await loggedFetch(LROOT + 'discount/' + encodeURIComponent(code));
        }
        const verifyCart = await loggedFetch(LROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        const titles = [];
        (verifyCart.cart_level_discount_applications || []).forEach(a => { if (a.title) titles.push(a.title.toUpperCase()); });
        (verifyCart.items || []).forEach(i => {
          (i.discounts || []).forEach(d => { if (d.title) titles.push(d.title.toUpperCase()); });
          (i.line_level_discount_allocations || []).forEach(a => {
            if (a.discount_application && a.discount_application.title) titles.push(a.discount_application.title.toUpperCase());
          });
        });
        /* Only count session codes that Shopify marks applicable.
           Fake/typo codes (e.g. "XYZNOTREAL") are added to
           cart.discount_codes with applicable=false — if we counted
           them, the verify step would pass for invalid inputs and
           fall into the "Non cumulable" branch instead of the proper
           "Code invalide" path. */
        (verifyCart.discount_codes || []).forEach((d) => {
          if (d.code && d.applicable) titles.push(d.code.toUpperCase());
        });

        if (!titles.includes(code.toUpperCase())) {
          /* Le code n'a pas pris. On tranche ICI, avec `verifyCart` sous la
             main : c'est la seule réponse qui porte le drapeau `applicable` et
             le contenu exact du panier. Le `throw` d'avant jetait les deux et
             laissait le catch redeviner la raison sans elles — d'où l'unique
             « Code invalide » pour trois situations différentes. */
          refuser(code, verifyCart, bundleActive);
          return;
        }

        /* Step 3: Code exists and applied. Pre-stacking has already
           handled the bundle+tier case — only NON-stackable user codes
           reach here with the bundle active, and we still want to show
           "Non cumulable" for those (Shopify would honour them but the
           merchant doesn't want them piled on the bundle). */
        if (bundleActive && !isStackableTierCode) {
          /* Remove the discount we just applied — not stackable */
          await loggedFetch(LROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'discount='
          });
          /* Re-apply oniix alone so the bundle discount survives the
             clear (auto-apply in promo-suggest.js will catch it on the
             next cart:refresh, but doing it here removes the flicker). */
          await loggedFetch(LROOT + 'discount/' + encodeURIComponent(bundleCode));
          poserMessage(qt.bundleOnly, 'refus');
          input.classList.add('onix-cart-drawer__discount-input--error');
          etatBouton(false);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        // Code applied and verified — no bundle conflict
        /* ⛔ UNE SEULE SOURCE DE VÉRITÉ — 31/08, 06h. Ces onze lignes
             recopiaient à la main ce que fait `setAppliedState()`, et en
             oubliaient une : **l'aria-label**. Résultat mesuré : après une
             application réussie, `applyBtn.__removeMode === true` pendant que
             le bouton affichait toujours ✓ et « Appliquer ».
             Le bouton disait APPLIQUER et exécutait RETIRER.
             Le clic suivant partait donc dans la branche de retrait du
             gestionnaire (ligne ~565) : un seul `POST /cart/update.js` avec
             `discount=`, aucun `/discount/CODE` derrière. Tracé à la pile
             d'appel — c'est ce qui faisait passer le panier de 37,40 à 44,00.
           ➜ On appelle le helper qui existe. Apparence et état interne ne
             peuvent plus diverger, parce qu'ils ne sont plus écrits à deux
             endroits. */
        sessionStorage.setItem('onix_pending_discount', code);
        setAppliedState(code);
        /* ⛔ ET UN DOUBLE-TAP NE DOIT PAS RETIRER — le geste le plus banal du
             mobile. Le bouton vient de changer de rôle sous le doigt : on
             ignore le retrait pendant un court instant après la bascule.
             Un vrai retrait, lui, arrive toujours plus d'une seconde après. */
        applyBtn.__basculeA = Date.now();
        document.dispatchEvent(new CustomEvent('cart:refresh'));

      } catch (e) {
        /* Ici, plus de refus métier — `refuser()` les traite tous avant, avec
           la réponse de Shopify en main. Ne restent que les vraies pannes :
           réseau coupé, JSON illisible. On ne sait alors RIEN du code, donc on
           ne prétend rien de plus que « ça n'a pas marché ».
           ⚠️ L'ancien chemin relançait un /cart.js ici pour deviner si l'offre
             était au panier — sur une panne réseau, ce second appel échouait à
             son tour et retombait sur le même message, une requête plus loin. */
        console.warn('[onix-cart] applyDiscount failed', e);
        poserMessage(qt.error, 'refus');
        input.classList.add('onix-cart-drawer__discount-input--error');
        etatBouton(false);
      }
    }

    /* Clear the error highlight + message as soon as the user starts editing. */
    /* ─────────────────────────────────────────────────────────────────
       LA MÊME VOIE, OUVERTE AUX AUTRES BLOCS DU TIROIR.
       L'offre « 2e maillot » annonce 17,50 € — le prix marginal du second une
       fois le palier appliqué (4998 − 749 − 2499). Elle ajoutait le maillot et
       s'arrêtait là : le client payait 24,99 € et devait TROUVER un second
       bouton « Appliquer » ailleurs dans le tiroir. Mesuré le 23/08, état
       stable, rien ne se corrigeait tout seul.
       Le bloc pose donc le code lui-même via window.__onixAppliquerPalier
       (cart-drawer-promo-suggest.js) — PAS par ce fichier : tout ce qui
       entoure un code (vérification côté Shopify, cumul avec le code interne
       du bundle, refus des codes déjà utilisés, bascule du bouton en
       « retirer ») vit dans applyDiscount et nulle part ailleurs. Un second
       chemin d'application aurait dupliqué ces cinq comportements — et n'en
       aurait tenu aucun à jour. */

    input.addEventListener('input', () => {
      input.classList.remove('onix-cart-drawer__discount-input--error');
      effacerMessage();
    });

    applyBtn.addEventListener('click', async () => {
      if (applyBtn.__removeMode) {
        /* ⛔ FENÊTRE DE GRÂCE APRÈS LA BASCULE — 31/08. Le bouton passe de
             « appliquer » à « retirer » au moment où le code prend. Un second
             appui dans la foulée est un double-tap, pas une demande de
             retrait : on l'ignore, et la remise reste. Mesuré avant :
             onix3 → 37,40 puis onix3 → 44,00. */
        if (applyBtn.__basculeA && (Date.now() - applyBtn.__basculeA) < 1200) return;
        applyBtn.textContent = '...';
        applyBtn.disabled = true;
        // Remove discount
        await loggedFetch(LROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'discount='
        });
        window.__onixDiscountCode = null;
        sessionStorage.removeItem('onix_pending_discount');
        input.disabled = false;
        input.value = '';
        etatBouton(false);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }
      applyDiscount();
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyDiscount();
      }
    });

    // Override checkout button to include discount.
    // The bundle code (oniix) and any tier code are already in the cart
    // session via the auto-apply + sequential /discount/CODE calls in
    // cart-drawer-promo-suggest.js, so they survive the redirect to
    // /checkout natively without us needing to pass them in the URL.
    // We only pass `?discount=USERCODE` to ensure a manually-typed
    // discount also survives — same behaviour as before this fix.
    document.addEventListener('click', (e) => {
      const checkoutBtn = e.target.closest('.onix-cart-drawer__checkout, a[href*="/checkout"]');
      if (checkoutBtn && window.__onixDiscountCode) {
        e.preventDefault();
        window.location.href = LROOT + 'checkout?discount=' + encodeURIComponent(window.__onixDiscountCode);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscount, { once: true });
  } else {
    initDiscount();
  }
})();

